module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: {
      "active": _vm.active
    },
    attrs: {
      "data-cat": _vm.item.id
    },
    on: {
      "click": _vm.filter
    }
  }, [(_vm.language === "en" && _vm.item.acf.english_name.length > 0) ? _c('span', [_vm._v(_vm._s(_vm.item.acf.english_name))]) : _c('span', [_vm._v(_vm._s(_vm.item.name))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f689f4f8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dsFilterItem.vue
// module id = 227
// module chunks = 2